import axios from "axios";

export default {
    data() {
        return {
            widgetsMixinResponse: null,
            isTeamManagerMixin: false,
        };
    },
    computed: {
        widgetsData() {
            if (!this.widgetsMixinResponse || !this.widgetsMixinResponse.data) {
                return { dashboard: [], menu: [] };
            }

            const data = this.widgetsMixinResponse.data;
            return {
                dashboard: Array.isArray(data.dashboard) ? data.dashboard : [],
                menu: Array.isArray(data.menu) ? data.menu : [],
            };
        },

        menuListMixin() {
            return this.widgetsData.menu;
        },

        dashboardListMixin() {
            return this.widgetsData.dashboard;
        },

        isEducationCategoryActiveMixin() {
            return this.isWidgetActive("education-category", "menu");
        },

        isStatisticsActiveMixin() {
            return this.isWidgetActive("my-statistics", "menu");
        },

        isGiftActiveMixin() {
            return this.isWidgetActive("gift", "menu");
        },

        isSolutionPartnerWidgetActive() {
            return this.isWidgetActive("solution_partners_apps", "menu");
        },

        // Widget açık + kullanıcı ekip yöneticisi olmalı
        isMyTeamActiveMixin() {
            return this.isWidgetActive("my_team", "menu") && this.isTeamManagerMixin;
        },

        isMyCompetencyActiveMixin() {
            return this.isWidgetActive("my_competency", "menu");
        },
    },
    methods: {
        getWidgetByType(type, source = "menu") {
            const widgets = this.widgetsData[source] || [];
            return widgets.find(widget => widget.type === type) || null;
        },

        isWidgetActive(type, source = "menu") {
            const widget = this.getWidgetByType(type, source);
            return widget ? widget.status === 1 : false;
        },

        getWidgetsMixin() {
            const widgetsRequest = axios.get(
                process.env.VUE_APP_BACKEND_APP_URL + "/api/widgets",
                {
                    params: {
                        company_id: this.authUser.company_id,
                        by_user: true,
                    },
                }
            );
            const selfRequest = axios
                .get(process.env.VUE_APP_BACKEND_APP_URL + "/api/user/self")
                .catch(() => null);

            return Promise.all([widgetsRequest, selfRequest]).then(
                ([widgetsResponse, selfResponse]) => {
                    this.widgetsMixinResponse = widgetsResponse;
                    this.isTeamManagerMixin = !!selfResponse?.data?.is_team_manager;
                    return widgetsResponse;
                }
            );
        },
    },
};
